import {PaginationState, SortingState} from '@tanstack/react-table'
import {getRaveUrlFilterData} from 'api/graphQL/queries/databases.queries'
import {createActionCreators, ImmerReducer} from 'immer-reducer'
import {genericRequestError} from 'redux/toast/toast.duck'
import defaultJobsState, {JobsStateType, FiltersType} from './state'
import {DatabaseMetadata, PageInfo} from 'graphql-api'
import {PaginationDirection, Status} from 'commonTypes'

class JobsGridSession extends ImmerReducer<JobsStateType> {
  paginationApplied(pagination: PaginationState) {
    this.draftState.gridSession.pagination = pagination
  }
  pageCountApplied(pageCount: number) {
    this.draftState.gridSession.pageCount = pageCount
  }
  resultsCountApplied(resultsCount: number) {
    this.draftState.gridSession.resultsCount = resultsCount
  }
  pageInfoApplied(pageInfo: PageInfo) {
    this.draftState.gridSession.pageInfo = pageInfo
  }
  cursorApplied(cursor: string) {
    this.draftState.gridSession.cursor = cursor
  }
  cursorReset() {
    this.draftState.gridSession.cursor = defaultJobsState.gridSession.cursor
  }
  paginationDirectionApplied(direction: PaginationDirection) {
    this.draftState.gridSession.paginationDirection = direction
  }
  paginationDirectionReset() {
    this.draftState.gridSession.paginationDirection = defaultJobsState.gridSession.paginationDirection
  }
  sortingApplied(sorting: SortingState) {
    this.draftState.gridSession.sorting = sorting
  }
  searchQueryApplied(searchQuery: string) {
    this.draftState.gridSession.filters.searchQuery = searchQuery
  }
  filtersApplied(filters: FiltersType) {
    this.draftState.gridSession.filters = filters
  }

  fetchFilterOptionsGO(){
    this.draftState.status = Status.PENDING
  }
  fetchFilterOptionsOK(databases: DatabaseMetadata[]){
    this.draftState.gridSession.filterOptions.raveUrl = databases
    this.draftState.status = Status.OK
  }
  fetchFilterOptionsERR(error){
    this.draftState.error = error
    this.draftState.status = Status.REJECTED
  }
}

export const fetchFilterOptions = () => async function(dispatch) {
  dispatch(JobsGridSessionAC.fetchFilterOptionsGO())
  try {
    const {data} = await getRaveUrlFilterData()
    if (data?.databases?.length) {
      dispatch(JobsGridSessionAC.fetchFilterOptionsOK(data?.databases))
    }
  } catch (err) {
    dispatch(genericRequestError())
    dispatch(JobsGridSessionAC.fetchFilterOptionsERR(err))
  }
}

export const JobsGridSessionAC = createActionCreators(JobsGridSession)

export default JobsGridSession
